<script lang="ts">
  import type { EditorMarking, EditorMarkings } from '../EditorMarkings.svelte';

  let {
    marking,
    markings,
  }: {
    marking: EditorMarking;
    markings: EditorMarkings;
  } = $props();
  const sidePadding = 2;
  const width = marking.rect.width + 2 * sidePadding;
  const defaultStyle = `
    top: ${marking.rect.top}px; 
    left: ${marking.rect.left - sidePadding}px; 
    width: ${width}px; 
    height: ${marking.rect.height}px;
    `;
  let style = $state(defaultStyle);

  $effect(() => {
    if (markings.focusedMarkerIds.includes(String(marking.markerId))) {
      style = 'display: none;';
    } else {
      style = defaultStyle;
    }
  });

  function onClick() {
    console.log('click', marking.markerId);
    console.log('current focused ids', markings.focusedMarkerIds);
    console.log(markings.focusedMarkerIds.includes(String(marking.markerId)));
  }

  function onMouseLeave() {
    if (markings.hoveredMarkerId === marking.markerId) {
      markings.hoveredMarkerId = undefined;
    }
  }
</script>

<div
  class="absolute w-0 rounded-sm transition-[width] duration-200"
  {style}
  role="button"
  tabindex="0"
  onclick={() => {
    markings.clickMarker(marking.markerId);
    onClick();
  }}
  onkeydown={(event) => event.key === 'Enter' && markings.clickMarker(marking.markerId)}
  onmouseenter={() => (markings.hoveredMarkerId = marking.markerId)}
  onmouseleave={onMouseLeave}
></div>
